module.exports = __webpack_public_path__ + "img/n-h-banner3.03c18c01.png";